import React from "react";
import { AdvertBadge } from "@/components/shared";

// Quiet advertising slot — drawn now, sold later.
export default function AdSlot({ slot, variant = "card" }) {
  if (!slot) return null;

  if (variant === "rail") {
    return (
      <aside
        data-testid={`ad-slot-${slot.slot_id}`}
        className="bg-[#F8F1E7] border border-dashed border-[#CDA434]/70 p-6 sticky top-24"
      >
        <div className="mb-4">
          <AdvertBadge label={slot.label} />
        </div>
        <h4 className="font-serif text-lg text-[#1E1E2F] mb-2">This berth is available</h4>
        <p className="font-sans text-sm text-[#505A68] leading-relaxed">{slot.house_copy}</p>
        <a
          href="/advertise"
          className="mt-4 inline-block font-sans text-sm font-semibold text-[#003366] link-underline"
        >
          Enquire about this slot →
        </a>
      </aside>
    );
  }

  if (variant === "strip") {
    return (
      <div
        data-testid={`ad-slot-${slot.slot_id}`}
        className="bg-[#1E1E2F] text-[#FFFAF3] p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t-2 border-[#CDA434]"
      >
        <div className="max-w-xl">
          <div className="mb-3">
            <span className="inline-flex items-center px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.18em] bg-[#CDA434]/20 text-[#CDA434] border border-[#CDA434]/50">
              {slot.label}
            </span>
          </div>
          <p className="font-sans text-sm text-[#FFFAF3]/80 leading-relaxed">{slot.house_copy}</p>
        </div>
        <a
          href="/advertise"
          className="font-sans text-sm font-semibold text-[#CDA434] whitespace-nowrap link-underline"
        >
          Take this berth →
        </a>
      </div>
    );
  }

  // inline card in a directory grid
  return (
    <div
      data-testid={`ad-slot-${slot.slot_id}`}
      className="bg-[#F8F1E7] border border-dashed border-[#CDA434]/70 p-6 flex flex-col justify-center min-h-[280px]"
    >
      <div className="mb-4">
        <AdvertBadge label={slot.label} />
      </div>
      <h4 className="font-serif text-lg text-[#1E1E2F] mb-2">A quiet advert could sit here</h4>
      <p className="font-sans text-sm text-[#505A68] leading-relaxed">{slot.house_copy}</p>
      <a
        href="/advertise"
        className="mt-4 font-sans text-sm font-semibold text-[#003366] link-underline"
      >
        See the media kit →
      </a>
    </div>
  );
}
